import React, { Component } from 'react'
import envUtil from '../utils/env.util'
import Heading from './Heading'
import Icon from './Icon'

interface PageHeadingProps {
  text: string
  doc?: string
  className?: string
}

export default class PageHeading extends Component<PageHeadingProps> {
  get className () {
    const base = 'flex gap-2 mb-4 items-center'
    return `${this.props.className} ${base}`
  }

  get doc () {
    const { doc } = this.props
    const { docUrl } = envUtil
    const link = `${docUrl}/#${doc}`
    return doc && docUrl &&
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className="flex">
        <Icon
          name='question'
          size="medium"
          color="gray" />
      </a>
  }

  render () {
    return (
      <div className={this.className}>
        <Heading
          text={this.props.text} />
        {this.doc}
      </div>
    )
  }
}
